module.exports = __webpack_public_path__ + "static/media/Gosha-Rubchinskiy-Red-X-Adidas-Jersey-Tee-for-Men-Lyst.c19e91f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/mens/Gosha-Rubchinskiy-Red-X-Adidas-Jersey-Tee-for-Men-Lyst.png
// module id = 255
// module chunks = 0